import { useFlags } from 'launchdarkly-react-client-sdk';

export const useFeaturesLoaded = () => {
  const flags = useFlags();

  return Boolean(Object.keys(flags).length);
};

export default useFeaturesLoaded;
